export const formatNumber = (value: number, options: Intl.NumberFormatOptions={}, explicitSign: boolean = false) => {
  if (isNaN(value))
    return '–';
  return `${explicitSign && value > 0 ? '+' : ''}${new Intl.NumberFormat('it-IT', options).format(value)}`;
}
export const formatCurrency = (value: number) => {
  return formatNumber(value, { style: 'currency', currency: 'EUR' });
}

export const formatPercentage = (value: number) => {
  const options = {style: 'percent', maximumFractionDigits: 2};
  return formatNumber(value, options, true);
}